import cn from "classnames"

import { Flex } from "@/atoms"

import styles from "./PulsingDotLabel.module.scss"

import type { PulsingDotLabelProps } from "."

export const PulsingDotLabel = (props: PulsingDotLabelProps) => {
  const { text, gap = 12, align = "center", disabled, theme, ...rest } = props

  return (
    <Flex align={align} gap={gap} {...rest}>
      <div
        className={cn(styles.dot, {
          [styles.dotDangerTheme]: theme === "danger",
          [styles.dotDisabled]: disabled
        })}
      />
      {text}
    </Flex>
  )
}
